import React from 'react';

import BasicModal from "../../SharedComponents/BasicModal";
import SvgIcon from "../../SharedComponents/Icons";

import './index.sass';


const ContractsFeaturesComparisonModal = ({ handleClose, paymentType, showModal }) => {


  return (
    <BasicModal
      mobileFullWidth={true}
      modalClass="contracts-features-modal"
      handleClose={handleClose}
      showModal={showModal}>
      <div className="contracts-features">
        <div className="contracts-features__headline">
          Sammenlign abonnementsmodeller
        </div>

        <p>Betalingsmodel { paymentType === 'year' ? '(Årlig betaling)' : '(Månedlig betaling)' }</p>

        <table className="contracts-features__table">
          <tbody>

            <tr className="contracts-features__table-header">
              <th>Priser</th>
              <th>Basic</th>
              <th>Basic Plus</th>
              <th>Premium</th>
            </tr>

            <tr className="contracts-features__table-header">
              <td>Pris pr. annonce pr. måned</td>
              <td>
                { paymentType === 'year'
                  ?
                    <div>
                      <div className="contracts-features__discounted-price">
                        199 kr.
                      </div>
                      <div className="contracts-features__price">
                        83 kr.
                      </div>
                    </div>
                  :
                    <div className="contracts-features__price">
                      199 kr.
                    </div>
                }
              </td>

              <td>
                { paymentType === 'year'
                  ?
                    <div>
                      <div className="contracts-features__discounted-price">
                        749 kr.
                      </div>
                      <div className="contracts-features__price">
                        208 kr.
                      </div>
                    </div>
                  :
                    <div className="contracts-features__price">
                      749 kr.
                    </div>
                }
              </td>

              <td>
                { paymentType === 'year'
                  ?
                    <div>
                      <div className="contracts-features__discounted-price">
                        1.449 kr.
                      </div>
                      <div className="contracts-features__price">
                        999 kr.
                      </div>
                    </div>
                  :
                    <div className="contracts-features__price">
                      1.449 kr.
                    </div>
                }
              </td>
            </tr>

            { paymentType === 'year' &&
              <tr className="contracts-features__yearly-price">
                <td>Årlig betaling pr. annonce</td>
                <td>999 kr.</td>
                <td>2.499 kr.</td>
                <td>11.988 kr.</td>
              </tr>
            }

            <tr className="contracts-features__features-header">
              <td>Du får</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            <tr className="contracts-features__features-row">
              <td>Annonce med kontaktformular</td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
            </tr>

            <tr>
              <td>Få henvendelser via e-mail & SMS</td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
            </tr>

            <tr>
              <td>Stor synlighed overfor potentielle lejere</td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
            </tr>

            <tr>
              <td>Personlig hjælp og support via telefon, e-mail og chat</td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
            </tr>

            <tr>
              <td>Ingen binding. Du kan altid skifte afregningsmodel</td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
            </tr>

            <tr>
              <td>Upload video til din annonce</td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
            </tr>

            <tr>
              <td><strong>Synlig e-mail & telefonnummer</strong>, så lejer kan skrive eller ringe direkte (giver ca. 100% flere henvendelser)</td>
              <td></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
            </tr>

            <tr>
              <td>Link til egen hjemmeside. Få mere trafik og henvendelser</td>
              <td></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
            </tr>

            <tr>
              <td>Visning af logo for branding</td>
              <td></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
            </tr>

            <tr>
              <td>Billede af kontaktperson</td>
              <td></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
            </tr>

            <tr>
              <td><strong>Stor, fremhævet annonce</strong>&nbsp;for maks. Eksponering og synlighed (Normalpris: 699 kr.)</td>
              <td></td>
              <td></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
            </tr>

            <tr>
              <td>Løbende&nbsp;<strong>Facebook kampagner</strong>&nbsp;på lejemål (Normalpris: 699 kr.)</td>
              <td></td>
              <td></td>
              <td><SvgIcon name="check" width={24} height={24} /></td>
            </tr>

          </tbody>
        </table>
      </div>
    </BasicModal>
  )
};

export default ContractsFeaturesComparisonModal;
